import React, { useEffect, useRef } from 'react';
import styled from '@emotion/styled';
import GoogleMapsService from 'services/google_maps';
import Icon from '../icon';
import './index.scss';
import { Theme } from 'ui_system/theme';

const InputWrapper = styled.div``;

const InputLocationIcon = styled.div`
  color: ${Theme.colors.iconsNotLinkedColor};
  position: absolute;
  top: 10px;
  left: 10px;

  @media screen and (max-width: 420px) {
    left: 6px;
  }
`;

const InputLocation = styled.input``;

const LocationInput = ({
  iconSize = 'regular',
  name,
  onChange,
  placeholder,
  value = null,
  dataTestId,
}) => {
  const ref = useRef();

  useEffect(() => {
    GoogleMapsService.onReady(() => {
      const autocomplete = new window.google.maps.places.Autocomplete(
        ref.current
      );
      window.google.maps.event.addListener(
        autocomplete,
        'place_changed',
        () => {
          const place = autocomplete.getPlace() || {};
          place.canonicalName = ref.current.value;
          onChange(place);
        }
      );
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <InputWrapper className="Input-Wrapper">
      <InputLocationIcon>
        <Icon icon="pin" theme={iconSize} />
      </InputLocationIcon>
      <InputLocation
        className="Input Input-Location"
        type="text"
        ref={ref}
        defaultValue={value}
        placeholder={placeholder}
        name={name}
        data-testid={dataTestId}
      />
    </InputWrapper>
  );
};

export default LocationInput;
